import PageInitializer from './libs/page-initializer';
import FocusVisibleManager from './libs/focus-visible-manager';
import { scrollToElement, updateUrlHash } from './libs/utils';
import { EVENT_READY, EVENT_UPDATE_VIEW } from './constants/event';
import './components/header';
import './components/target-slider';
import './components/hero';
import './components/history';
import './components/fixed-cta';

// フォーカス表示管理の初期化
FocusVisibleManager.getInstance();

// アンカーリンクのスムーススクロール処理を初期化
function initializeAnchorScroll(): void {
  // 既存の処理を上書きするため、キャプチャフェーズで処理
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const anchor = target.closest('a[href]') as HTMLAnchorElement;
    
    if (!anchor) return;

    if(anchor.classList.contains('ignore-anchor-scroll')){
      return;
    }
    
    const href = anchor.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    
    // 既存のイベントを停止
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // メニューが開いている場合は閉じる
    const header = document.querySelector('.js-header');
    if (header && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      // ScrollLockも解除
      const body = document.body;
      body.style.overflow = '';
    }
    
    // ターゲット要素を取得してスクロール
    const targetId = href.slice(1);
    scrollToElement(targetId);
    
    // URLにハッシュを追加（履歴に残す）
    updateUrlHash(href);
  }, true); // trueでキャプチャフェーズで処理（既存の処理より先に実行）
}

PageInitializer.getInstance()
  .ready()
  .then(() => {
    const body = document.body;
    body.classList.add('is-loaded');

    document.dispatchEvent(new Event(EVENT_READY));
    
    // コンポーネントの初期化をトリガー
    document.dispatchEvent(new CustomEvent(EVENT_UPDATE_VIEW));
    
    // アンカーリンクのスムーススクロール処理を初期化
    initializeAnchorScroll();
  });
